<template>
    <transition
        @enter="enterTransition"
        @leave="leaveTransition"
        :css="false"
        :appear="$_appear"
    >
        <div class="oc-modal-holder" v-show="show">
            <div class="modal-backdrop show" v-if="backdrop"></div>
            <div class="modal" tabindex="-1" @click="doCloseOnBackdrop">
                <div v-class="['modal-dialog', {'modal-dialog-centered' : alignVertically}, 'modal-' + $_size]">
                    <div class="modal-content">
                        <div class="modal-header" v-class="themeHeaderColors[type]" v-if="titleVisible">
                            <slot name="header">
                                <h5 class="modal-title" v-if="titleVisible">
                                    <slot name="title">{{title}}</slot>
                                </h5>
                                <oc-button-input v-if="closeButton" @click="$emit('close')" class="close" v-class="themeHeaderCloseColors[type]">
                                    <span aria-hidden="true">&times;</span>
                                </oc-button-input>
                            </slot>
                        </div>
                        <div class="modal-body" v-if="contentVisible">
                            <oc-button-input v-if="!titleVisible && closeButton" @click="$emit('close')" class="close">
                                <span aria-hidden="true">&times;</span>
                            </oc-button-input>

                            <slot>
                                <template v-if="content">
                                    <template v-if="escape">{{content}}</template>
                                    <div v-else v-html="content" />
                                </template>
                                <oc-dynamic-structure
                                    v-else-if="false !== schema"
                                    :schema="schema"
                                 />
                            </slot>
                        </div>
                        <div class="modal-footer" v-if="footerVisible">
                            <slot name="footer">
                                <slot name="buttons-before"></slot>
                                <oc-button
                                    v-for="(button, index) in $_buttons"
                                    :key="index"
                                    v-bind="button.attrs"
                                    v-class="button.classes"
                                    v-on="button.events"
                                />
                                <slot name="buttons-after"></slot>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import Velocity from 'velocity'

export default {
    name: 'oc-modal',
    props: {
        title: {
            type: [Number, String]
        },
        content: {
            type: [Number, String]
        },
        show: {
            type: Boolean,
            default: true
        },
        appear: {
            type: Boolean,
            default: true
        },
        escape: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'default',
            validator: function (value) {
                return ['default', 'success', 'warning', 'danger', 'info'].indexOf(value) !== -1
            }
        },
        displayHeader: {
            type: Boolean,
            default: true
        },
        displayContent: {
            type: Boolean,
            default: true
        },

        /**
         * Parameters are the same as in <oc-button />
         * Example:
         * [
         *   {
         *       text: 'Cancel'
         *       on: {
         *           click: {
         *               // do something
         *           }
         *       }
         *   },
         *   {
         *       text: 'Export',
         *       type: 'primary',
         *       tag: 'a',
         *       ...
         *   }
         * ]
         *
         * If boolean FALSE is given - default buttons will be loaded
         *
         * @type {Object}
         */
        buttons: {
            type: [Array, Boolean, Function],
            default: false
        },
        displayCancelButton: {
            type: Boolean,
            default: true
        },
        cancelButtonText: {
            type: String,
            default: 'Cancel'
        },
        cancelButtonAttrs: {
            type: Object,
            default: () => ({})
        },
        displayConfirmButton: {
            type: Boolean,
            default: true
        },
        confirmButtonText: {
            type: String,
            default: 'Confirm'
        },
        confirmButtonAttrs: {
            type: Object,
            default: () => ({})
        },
        closeButton: {
            type: Boolean,
            default: true
        },
        backdrop: {
            type: Boolean,
            default: true
        },
        closeOnBackdrop: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return ['small', 'normal', 'big', 'large'].indexOf(value) !== -1
            }
        },
        alignVertically: {
            type: Boolean,
            default: false
        },
        closeAnimation: {
            type: Boolean,
            default: true
        },
        openAnimation: {
            type: Boolean,
            default: true
        },
        animation: {
            type: [Boolean, String],
            default: 'ease',
            validator: function (value) {
                return [false, 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out'].indexOf(value) !== -1
            }
        },
        schema: {
            type: [Object, Boolean],
            default: false
        }
    },
    created() {
        // fix for <oc-modal v-show="cond" /> legacy wrong use
        if( this.$vnode && this.$vnode.data.directives )
        {
            let filtertedDirectives = this.$vnode.data.directives.filter((item) => {
                return item.name === 'show'
            })

            if( filtertedDirectives.length > 0 ) {
                this._appear = false
            }
        }
    },
    destroyed() {
        this.restoreBodyOverflow()
    },
    data() {
        return {
            _appear: undefined,
            themeHeaderColors: {
                default: [],
                success: ['bg-success', 'text-white'],
                danger: ['bg-danger', 'text-white'],
                warning: ['bg-warning', 'text-dark'],
                info: ['bg-info', 'text-white']
            },
            themeHeaderCloseColors: {
                default: [],
                success: ['text-white'],
                danger: ['text-white'],
                info: ['text-white']
            }
        }
    },
    methods: {
        restoreBodyOverflow() {
            // find all remaining active modals on the page
            var all = document.querySelectorAll('.oc-modal-holder')

            const isHidden = (el) => {
                var style = window.getComputedStyle(el)
                return ((style.display === 'none') || (style.visibility === 'hidden'))
            }

            let foundActiveModals = false
            for( let el of all ) {
                if( el !== this.$el && ! isHidden(el) ) {
                    foundActiveModals = true
                    break
                }
            }

            if( ! foundActiveModals ) {
                document.getElementsByTagName('body')[0].style.overflow = ''
            }
        },
        doCloseOnBackdrop(e) {
            if( this.closeOnBackdrop && e.target === e.currentTarget ) {
                this.$emit('close')
            }
        },
        enterTransition (el, done) {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden'

            let complete = () => {
                done()
                this.$emit('open-complete')
            }

            if(false === this.animation || false === this.openAnimation) {
                return complete()
            }
            Velocity(el, "fadeIn", { duration: 350, easing: this.animation, complete: complete})
        },
        leaveTransition (el, done) {
            this.restoreBodyOverflow()

            let complete = () => {
                done()
                this.$emit('close-complete')
            }

            if(false === this.animation || false === this.closeAnimation) {
                return complete()
            }
            Velocity(el, "fadeOut", { duration: 350, easing: this.animation, complete: complete})
        }
    },
    computed: {
        $_appear() {
            return this._appear !== undefined ? this._appear : this.appear
        },
        titleVisible() {
            return this.displayHeader && ( this.title || this.$slots.title )
        },
        contentVisible() {
            return this.displayContent && ( this.content || this.$slots.default || false !== this.schema )
        },
        footerVisible() {
            return this.$_buttons.length > 0 || this.$slots.footer
        },
        $_size() {
            let sizes = {
                small: 'sm',
                normal: 'md',
                big: 'lg',
                large: 'xl'
            }

            return sizes[this.size]
        },
        $_buttons() {
            let buttonsRaw = []

            if( false === this.buttons || typeOf(this.buttons) === 'function' )
            {
                if( this.displayCancelButton ) {
                    buttonsRaw.push(
                        Object.assign({
                            text: this.cancelButtonText,
                            type: 'secondary',
                            on: {
                                click: function() {
                                    this.$emit('close')
                                }.bind(this)
                            }
                        }, this.cancelButtonAttrs)
                    )
                }

                if( this.displayConfirmButton ) {
                    let confrimButtonType = 'primary'
                    if( this.type !== 'default' ) {
                        confrimButtonType = this.type
                    }

                    buttonsRaw.push(
                        Object.assign({
                            text: this.confirmButtonText,
                            type: confrimButtonType,
                            on: {
                                click: function() {
                                    this.$emit('confirm')
                                }.bind(this)
                            }
                        }, this.confirmButtonAttrs)
                    )
                }

                if( typeOf(this.buttons) === 'function' ) {
                    buttonsRaw = this.buttons(buttonsRaw)
                }
            } else {
                buttonsRaw = this.buttons
            }

            let buttons = []

            for( let button of buttonsRaw ) {
                let attrs = Object.assign({}, button)
                let events = attrs.on
                let classes = attrs.class
                delete attrs.on
                delete attrs.class

                buttons.push({
                    attrs,
                    events,
                    classes
                })
            }

            return buttons
        }
    }
}
</script>
<style scoped>
.oc-modal-holder {
    z-index:1040;
    position: absolute;
}
.oc-modal-holder .modal {
    display:block;
    overflow-y: auto;
}

.oc-modal-holder .modal-content {
    border: none;
}

.oc-modal-holder .modal .modal-body {
    font-size: 14px;
}

.oc-modal-holder .modal .modal-footer button {
    font-size: 14px;
}

.oc-modal-holder .modal .modal-header {
    padding: 0.8rem 1rem;
}
    .oc-modal-holder .modal .modal-header .modal-title {
        font-size: 16px;
        font-weight: normal;
    }
    .oc-modal-holder .modal .modal-header .close {
        padding: 0.5rem 1rem 0.9rem 1rem;
        margin: -0.7rem -1rem -0.7rem auto;
    }
</style>
